import { ReactElement } from 'react';
import RiskAndSupportDetails from '@components/FVSPage/RiskAndSupportDetails';
import { fvsInfoDisplayObject } from '@services/FormFieldConfig';

function FVSStep7(): ReactElement {
  return (
    <>
      <RiskAndSupportDetails displayObject={fvsInfoDisplayObject} currentStepNo="step7" />
    </>
  );
}

export default FVSStep7;
